(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9039],{

/***/ 1700:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tiles/living-room-tiles",
      function () {
        return __webpack_require__(74218);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 74218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Page; },
/* harmony export */   "getProductQueryServerSide": function() { return /* binding */ getProductQueryServerSide; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _src_components_newProductCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73403);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31230);
/* harmony import */ var _src_UnbxdProductCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64642);
/* harmony import */ var _src_productCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93115);
/* harmony import */ var _src_components_category__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95173);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83346);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query Products(\n    $filter: ProductAttributeFilterInput!\n    $sort: ProductAttributeSortInput!\n    $pageSize: Int!\n    $currentPage: Int!\n  ) {\n    products(\n      filter: $filter\n      sort: $sort\n      pageSize: $pageSize\n      currentPage: $currentPage\n    ) {\n      currentcategory {\n        name\n        description\n        dynamic_content\n        imageUrl\n        meta_keywords\n        meta_description\n        meta_title\n        schema\n        breadcrumbs {\n          category_id\n          category_name\n          category_level\n          category_url_key\n          category_url_path\n        }\n      }\n      appliedFilters {\n        label\n        value\n        attribute_code\n      }\n      aggregations(filter: { category: { includeDirectChildrenOnly: true } }) {\n        attribute_code\n        count\n        label\n        options {\n          label\n          value\n          count\n          swatch_data {\n            type\n            value\n          }\n        }\n      }\n      subcategories {\n        id\n        name\n        imageUrl\n      }\n      total_count\n      items {\n        id\n        name\n        sku\n        url_key\n        price_range {\n          minimum_price {\n            regular_price {\n              value\n              currency\n            }\n            final_price {\n              value\n              currency\n            }\n            discount {\n              amount_off\n              percent_off\n            }\n          }\n          maximum_price {\n            regular_price {\n              value\n              currency\n            }\n            final_price {\n              value\n              currency\n            }\n            discount {\n              amount_off\n              percent_off\n            }\n          }\n        }\n        extraVariables {\n          skd_stock\n          dora_stock\n          hoskote_stock\n          west_zone_stock\n          tile_type\n          tile_area\n          factory\n          finish {\n            label\n            value\n            url_key\n          }\n          tile_design\n          is_enabled\n          is_new\n          image_url\n          ambience_image_url\n          product_url\n          tile_size\n          sq_ft_price\n        }\n      }\n      sort_fields {\n        default\n        options {\n          value\n          label\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}










var __N_SSP = true;
const getProductQueryServerSide = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_10__/* .gql */ .Ps)(_templateObject());
const livingTileSections = [
    {
        type: "Explore Living Room Floor Tiles",
        name: "floor",
        description: "Tiles give your living room a picture-perfect ambience, and when it comes to floor tiles, nothing can beat them. They are the first detail that catches the attention of anyone who steps into your home and have the power to redefine the room’s overall style. Whether your interior inspiration is modern or leaning towards a cozy, rustic vibe, the right floor tiles can enhance the overall aesthetic of your living room. From luxurious marble to beautiful wood-look tile, these flooring ideas for your living room are chic and easy-to-clean carpet alternatives. Choosing a suitable style, texture, and colour will make your living room cosy and trendy, so it remains a cherished haven for family and friends. So, take your time  browsing for different options to achieve the perfect match that speaks to your unique sense but provides the durability you need for everyday life."
    },
    {
        type: "Explore Living Room Wall Tiles",
        name: "wall",
        description: "The walls of your living room are a blank canvas; turn yours into a masterpiece with wall tiles. The living room is a space where functionality and comfort come together, cohesively blending relaxation, entertainment, and everyday living.  With the right wall tiles, you can elevate the ambience, add character, and create a style statement that reflects your personality.From creating an accent wall that serves as a striking focal point to adding a dramatic effect through textures and patterns, the perfect wall tiles can completely transform your living room d\xe9cor.You’re only limited by your imagination, and at Orientbell Tiles, each of our collections offers a rich palette of colours, textures, and styles to help you shape a living space that reflects your unique taste."
    }
];
function Page(param) {
    let { error , oldComponent =false , oldComponentProps , sizeProductList  } = param;
    var ref, ref1, ref2, ref3;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { data  } = oldComponentProps;
    const [oldComponentState, setOldComponentState] = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(oldComponent);
    // Function to relocate to new UI Component
    oldComponentProps = {
        ...oldComponentProps,
        removeAllFilterAndRedirect: ()=>setOldComponentState(false)
    };
    if (error) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        children: error
    });
    if (oldComponentState) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_components_category__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        ...oldComponentProps
    });
    const breadsCrumbSchema = (cat)=>{
        let arr = [
            {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.orientbell.com"
            }
        ];
        for(let i = 0; i < cat.breadcrumbs.length; i++){
            arr.push({
                "@type": "ListItem",
                position: i + 2,
                name: cat.breadcrumbs[i].category_name,
                item: "https://www.orientbell.com/".concat(cat.breadcrumbs[i].category_url_path)
            });
        }
        return {
            __html: JSON.stringify({
                "@context": "https://schema.org/",
                "@type": "BreadcrumbList",
                itemListElement: arr
            })
        };
    };
    const webPageSchema = ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6;
        return {
            __html: '{\n        "@context": "https://schema.org",\n        "@type": "WebPage",\n        "url": "'.concat(router.asPath, '",\n        "headline": "",\n        "breadcrumb": "Home > Tiles > ').concat(((ref = data.products.currentcategory) === null || ref === void 0 ? void 0 : ref.breadcrumbs) ? (ref2 = (ref1 = data.products.currentcategory) === null || ref1 === void 0 ? void 0 : ref1.breadcrumbs[1]) === null || ref2 === void 0 ? void 0 : ref2.category_name : "", '",\n        "name": "').concat((ref3 = data.products) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.currentcategory) === null || ref4 === void 0 ? void 0 : ref4.meta_title, '",\n        "description": "').concat((ref5 = data.products) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.currentcategory) === null || ref6 === void 0 ? void 0 : ref6.meta_description, '"\n      }')
        };
    };
    // New UI rendering
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_8___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        charset: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "title",
                        content: data.products.currentcategory.meta_title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                        children: data.products.currentcategory.meta_title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "description",
                        content: data.products.currentcategory.meta_description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "keywords",
                        content: data.products.currentcategory.meta_keywords
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "format-detection",
                        content: "telephone=no"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "preconnect dns-prefetch",
                        href: "https://connect.facebook.net",
                        crossorigin: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "preconnect dns-prefetch",
                        href: "https://www.googletagmanager.com",
                        crossorigin: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        "http-equiv": "Accept-CH",
                        content: "viewport-width, width, device-memory, dpr, downlink, ect"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "pinterest-rich-pin",
                        content: "false"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "twitter:description",
                        content: data.products.currentcategory.meta_description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "twitter:title",
                        content: data.products.currentcategory.meta_title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "twitter:image",
                        content: "".concat(_config__WEBPACK_IMPORTED_MODULE_9__/* ["default"].API_ENDPOINT */ .Z.API_ENDPOINT, "/media/img/logo.png")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "twitter:site",
                        content: "Orientbell"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "Orientbell"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:url",
                        content: "".concat(_config__WEBPACK_IMPORTED_MODULE_9__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/").concat(router.query.category ? router.query.category.join("/") : "/tiles")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:description",
                        content: data.products.currentcategory.meta_description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:title",
                        content: data.products.currentcategory.meta_title
                    }),
                    ((ref = data.products) === null || ref === void 0 ? void 0 : (ref1 = ref.currentcategory) === null || ref1 === void 0 ? void 0 : ref1.schema) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: data.products.currentcategory.schema.split(/<script[^>]*>/g) // Split by opening <script> tags
                        .filter((schema)=>schema.trim()) // Filter out any empty strings
                        .map((schemaContent, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                                type: "application/ld+json",
                                dangerouslySetInnerHTML: {
                                    __html: schemaContent.replace(/<\/script>/g, "")
                                }
                            }, index))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:image",
                        content: "".concat(_config__WEBPACK_IMPORTED_MODULE_9__/* ["default"].API_ENDPOINT */ .Z.API_ENDPOINT, "/media/img/logo.png")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "text/javascript",
                        src: "https://cdn.roomvo.com/static/scripts/b2b/orientbell.js",
                        defer: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: webPageSchema()
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: breadsCrumbSchema(data.products.currentcategory)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
                className: "category-bathroom-tile-section new-cate-bath-tile-sect",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "container container-width",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "bread-crumb-row",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                            href: _config__WEBPACK_IMPORTED_MODULE_9__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL,
                                            children: "Home"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                            href: "/tiles",
                                            children: "Tiles"
                                        })
                                    }),
                                    data.products.currentcategory.breadcrumbs && data.products.currentcategory.breadcrumbs.map((bre, inddd)=>{
                                        if (inddd != 0 && bre.category_name != "All Tiles") {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("li", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    href: "/".concat(bre.category_url_path),
                                                    children: bre.category_name
                                                })
                                            }, inddd);
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "categry-heading-row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                                    children: "Living Room Tiles"
                                }),
                                ((ref2 = data.products) === null || ref2 === void 0 ? void 0 : ref2.currentcategory.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "category_accordion_data ",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: data.products.currentcategory.description.replace(/<p>\s*<\/p>/g, "")
                                        }
                                    })
                                })
                            ]
                        }),
                        livingTileSections.map((section, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "categry-tile-prod-row",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "exp-tile-text-row",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                                children: [
                                                    " ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                                                        children: section.type
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        href: section.name === "wall" ? "/tiles/living-room-tiles/living-room-wall-tiles" : "/tiles/living-room-tiles/living-room-floor-tiles",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                            className: "btn btn-primary",
                                                            children: "View All"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                children: section.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
                                        className: "categry-explore-wrap",
                                        children: sizeProductList[section.name].map((obj, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "categry-explore-size-head",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h3", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                    children: obj.size
                                                                }),
                                                                " Living Room",
                                                                " ",
                                                                section.name.replace(/^./, (char)=>char.toUpperCase()),
                                                                " ",
                                                                "Tiles"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "categry-explore-row",
                                                        children: Array.isArray(obj.product) && obj.product.map((prod, productIndex)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_src_components_newProductCard__WEBPACK_IMPORTED_MODULE_3__/* .NewProductCard */ .u, {
                                                                product: prod
                                                            }, productIndex))
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: "explore-pro-btn-row",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                            href: "/tiles/living-room-tiles/".concat(obj.size).concat(obj.size !== "600x600" ? "/" + (section.name === "wall" ? "walls-tiles" : "floor-tiles") : ""),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                                                className: "btn btn-primary",
                                                                children: "View More"
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, idx))
                                    })
                                ]
                            }, index)),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "category_accordion_data",
                            dangerouslySetInnerHTML: {
                                __html: (ref3 = data.products) === null || ref3 === void 0 ? void 0 : ref3.currentcategory.dynamic_content.replace(/<p>\s*(&nbsp;)?\s*<\/p>/g, "")
                            }
                        })
                    ]
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7361,5518,4585,7615,6212,6737,7528,7933,3372,7349,166,4441,9774,2888,179], function() { return __webpack_exec__(1700); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);